/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
import React, { useCallback, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { EuiSpacer, EuiTitle } from "@elastic/eui";
import { updateTripPrices } from "modules/trips/api";
import SectionsCard from "../shared/tripReconiliation/SectionsCard";
import ExpensesFields from "../shared/tripReconiliation/ExpensesFields";
import { TripPiceBox } from "./style";

const VariableExpenses = ({ tripId, tripPrices, setIsPricesChanged, isPricesChanged }) => {
    const intl = useIntl();
    const [expenseTotals, setExpenseTotals] = useState({});
    const [switchStates, setSwitchStates] = useState({});
    const [isSaved, setIsSaved] = useState(true);

    const expenseItems = useMemo(
        () => [
            {
                id: 1,
                key: "gas_and_oil",
                label: <FormattedMessage id="trip.reconciliation.variableexpenses.oil" />,
                showPrice: true,
                showTotal: true,
                showNotes: true,
                prepend: <FormattedMessage id="km" />,
                showCount: true,
                expenseValue: tripPrices?.gasAndOil,
            },
            {
                id: 2,
                key: "delay_and_late_show",
                label: <FormattedMessage id="trip.reconciliation.variableexpenses.delayandshow" />,
                showPrice: true,
                showTotal: true,
                showNotes: true,
                prepend: <FormattedMessage id="hour" />,
                showCount: true,
                isDeduction: true,
                expenseValue: tripPrices?.delayAndLateShow,
            },
            {
                id: 3,
                key: "overnight_stay",
                label: <FormattedMessage id="trip.reconciliation.variableexpenses.overnigthstay" />,
                showPrice: true,
                showTotal: true,
                showNotes: true,
                prepend: <FormattedMessage id="day" />,
                showCount: true,
                expenseValue: tripPrices?.overnightStay,
            },
            {
                id: 4,
                key: "extra_kilometer",
                label: <FormattedMessage id="trip.reconciliation.variableexpenses.extrakms" />,
                showPrice: true,
                showTotal: true,
                showNotes: true,
                prepend: <FormattedMessage id="km" />,
                showCount: true,
                expenseValue: tripPrices?.extraKilometer,
            },
            {
                id: 5,
                key: "extra_drop_off",
                label: <FormattedMessage id="trip.reconciliation.variableexpenses.extradropoff" />,
                showPrice: true,
                showTotal: true,
                showNotes: true,
                prepend: <FormattedMessage id="point" />,
                showCount: true,
                expenseValue: tripPrices?.extraDropOff,
            },
        ],
        [intl.locale, tripPrices]
    );
    // Handler to update totals for each expense item
    const handleTotalChange = useCallback((id, { price, quantity, notes, total }) => {
        setExpenseTotals((prevTotals) => ({
            ...prevTotals,
            [id]: { price, quantity, notes, total, switchState: switchStates[id] || false },
        }));
    }, []);

    // Calculate the overall total
    const calculateTotalExpenses = useMemo(() => {
        return expenseItems.reduce((sum, item) => {
            const expense = expenseTotals[item.id] || {};
            const total = expense.total || 0;
            const isSwitchOn = switchStates[item.id] || false;
            // Subtract total if the item is marked as deduction
            return isSwitchOn ? (item.isDeduction ? sum - total : sum + total) : sum;
        }, 0);
    }, [expenseItems, expenseTotals]);

    // // Prepare the payload for the backend
    // const preparePayload = () => {
    //     const payload = expenseItems.reduce((result, item) => {
    //         const expense = expenseTotals[item.id] || {};
    //         const isSwitchOn = switchStates[item.id];
    //         if (isSwitchOn && (expense.price || expense.quantity || expense.notes)) {
    //             result[item.key] = {
    //                 price: expense.price || 0,
    //                 quantity: expense.quantity || 0,
    //                 ...(expense.notes && { notes: expense.notes }),
    //             };
    //         }
    //         return result;
    //     }, {});
    //     return { trip_price: payload };
    // };
    const preparePayload = () => {
        const payload = expenseItems.reduce((result, item) => {
            const expense = expenseTotals[item.id] || {};

            result[item.key] = {
                price: expense.price || 0,
                quantity: expense.quantity || 0,
                ...(expense.notes !== undefined && { notes: expense.notes }),
            };
            return result;
        }, {});
        return { trip_price: payload };
    };

    // Mock API call
    const handleSubmit = () => {
        const payload = preparePayload();
        updateTripPrices(tripId, payload).then(() => {
            setIsSaved(true);
            setIsPricesChanged(!isPricesChanged);
        });
    };

    const handleSwitchChange = (id, isOn) => {
        setSwitchStates((prevStates) => ({
            ...prevStates,
            [id]: isOn,
        }));
    };

    return (
        <SectionsCard
            title={<FormattedMessage id="trip.reconciliation.variableexpenses.title" />}
            showButton
            onButtonClick={handleSubmit}
            isButtonDisabled={isSaved}
        >
            <TripPiceBox>
                <h4>
                    {" "}
                    <FormattedMessage id="trip.reconciliation.variableexpenses.total" />
                </h4>
                <EuiTitle size="s">
                    <p>{calculateTotalExpenses}</p>
                </EuiTitle>
            </TripPiceBox>
            <EuiSpacer size="m" />
            {expenseItems.map((item) => {
                return (
                    <ExpensesFields
                        key={item.id}
                        label={item.label}
                        showNotes={item.showNotes}
                        showPrice={item.showPrice}
                        showTotal={item.showTotal}
                        append={item.prepend}
                        showCount={item.showCount}
                        onTotalChange={handleTotalChange}
                        expenseValue={item.expenseValue}
                        id={item?.id}
                        onSwitchChange={handleSwitchChange}
                        isSwitchOn={switchStates[item.id] || false}
                        setIsSaved={setIsSaved}
                        isTotalDeducted={item.isDeduction}
                        setSwitchStates={setSwitchStates}
                    />
                );
            })}
        </SectionsCard>
    );
};

export default VariableExpenses;
